import type { DashboardState } from 'store/entities/dashboard'; //TODO TYPES

import type { DrawerState } from 'store/entities/drawer';
import type { UiState } from 'store/entities/ui';

import type { AuthState, LanguageSliceType, NavigationStateStore, TableQueryType } from 'types';
import type { HeliosConditionsState } from 'store/entities/helios/heliosConditions';
import type { HeliosNotificationConditionsState } from 'store/entities/helios/heliosNotificationConditions';
import type { ChatbotState } from 'store/entities/chatbot';

export enum REDUCER_PATHS {
  USER = 'user',
  LOGIN = 'login',
}

enum TAG_TYPES_CORE {
  USERS = 'User',
  USER_DETAIL = 'UserDetail',
  LOGIN = 'Login',
  MODULES = 'Modules',
  SETTINGS = 'Settings',
  ROLES = 'Roles',
  ROLE_DETAIL = 'RoleDetail',
  FAVORITE_USER_MODULES = 'FavoriteUserModules',
  NOTIFICATIONS = 'Notifications',
  SUBSTITUTABILITY = 'Substitutability',
  USER_SUBSTITUTIONS = 'UserSubstitutions',
  USER_SUBSTITUTION_DETAIL = 'UserSubstitutionDetail',
  USER_SUBSTITUTIONS_AS_SUBSTITUTE = 'UserSubstitutionsAsSubstitute',
  DASHBOARD = 'Dashboard',
  USER_NOTIFICATIONS = 'UserNotifications',
  ASSISTANTS = 'Assistants',
  SHARE_GRANTS = 'ShareGrants',
}

enum TAG_TYPES_FLOW {
  TABLE = 'Table',
  TABLE_DETAIL = 'TableDetail',
  NOTIFICATION_TEMPLATES = 'NotificationTemplates',
  VIEWS = 'Views',
  VIEW = 'View',
  AGENDAS = 'Agendas',
  AGENDAS_FAVORITE = 'AgendasFavorites',
  AGENDAS_IMPORTS = 'AgendasImports',
  CONDITIONS = 'Conditions',
  LOOKUPS = 'Lookups',
  RECORDS = 'Records',
  COLUMNS = 'Columns',
  SHARED_NOTIFICATIONS = 'SharedNotifications',
  USER_GROUPS = 'UserGroups',
  USER_FILTERS = 'UserFilters',
  CRM = 'Crm',
  REST_API_CONNECTIONS = 'RestApiConnections',
}

enum TAG_TYPES_HELIOS {
  DATASOURCES = 'Datasources',
  TEMPLATES = 'Templates',
  USER_DEFINED_ATTRIBUTES = 'UserDefinedAttributes',
  AGGREGATION_GROUPS = 'AggregationGroups',
  TEMPLATE_FUNCTIONS = 'TemplateFunctions',
  TEMPLATE_ROLES = 'TemplateRoles',
  FUNCTIONS = 'Functions',
  DATA_HELIOS = 'DataHelios',
  DATA_TABLES_HELIOS = 'DataTablesHelios',
  IMPORT_TEMPLATES = 'ImportTemplates',
  CHECK_USERS = 'CheckHeliosUsers',
  FORMS = 'Forms',
  FILES = 'HeliosFiles',
  HELIOS_USER_FILTERS = 'HeliosUserFilters',
  FAVORITE_TEMPLATES = 'FavoriteTemplates',
}

enum TAG_TYPES_DOCUMENT_STORAGE {
  FILES = 'Files',
}

export const TAG_TYPES = {
  ...TAG_TYPES_CORE,
  ...TAG_TYPES_FLOW,
  ...TAG_TYPES_HELIOS,
  ...TAG_TYPES_DOCUMENT_STORAGE,
};

export enum SLICER_KEYS {
  API_HEADERS = 'apiHeaders',
  AUTH = 'auth',
  DASHBOARD = 'dashboard',
  LANGUAGE = 'language',
  TABLE_QUERY = 'tablesQuery',
  NAVIGATION_STATE = 'navigationState',

  DRAWER_STATE = 'drawerState',
  BLOCKER_MODALS_STATE = 'blockerModalsState',

  CHATBOT = 'chatbot',

  //HELIOS
  HELIOS_CONDITIONS = 'heliosConditions',
  HELIOS_NOTIFICATION_CONDITIONS = 'heliosNotificationConditions',

  //FLOW
  MODULES_AND_AGENDAS = 'modulesAndAgendas',

  //HELIOS
  TEMPLATE_FORMS = 'templateForms',

  //UI
  UI_STATE = 'uiState',
}

export interface Slicers {
  [SLICER_KEYS.AUTH]: AuthState;
  [SLICER_KEYS.LANGUAGE]: LanguageSliceType;
  [SLICER_KEYS.NAVIGATION_STATE]: NavigationStateStore;
  [SLICER_KEYS.DASHBOARD]: DashboardState;
  [SLICER_KEYS.CHATBOT]: ChatbotState;

  [SLICER_KEYS.DRAWER_STATE]: DrawerState;
  [SLICER_KEYS.HELIOS_CONDITIONS]: HeliosConditionsState;
  [SLICER_KEYS.HELIOS_NOTIFICATION_CONDITIONS]: HeliosNotificationConditionsState;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [SLICER_KEYS.TABLE_QUERY]: TableQueryType<any, any> | undefined;
  [SLICER_KEYS.UI_STATE]: UiState;
}
